
import {makeStyles} from '@material-ui/core/styles'

const useStyles = makeStyles( theme => ({
    center: {
        textAlign: "center"
    },
    compoundViewTable: {
        margin: "20px 0"
    }
}))

export default useStyles